import React, { useState, useEffect } from "react";
import * as API from "../../utils/api.service";
import { Controller, useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import SubNavbar from "../../layout/SubNavbar";
import { setLoader } from "../../Store/slices/MasterSlice";
import { uploadImageOnAWS } from "../../utils/aws.service";
import { IoMdArrowRoundBack } from "react-icons/io";
import {
  convertToBase64,
  TOAST_ERROR,
  SWIT_SUCCESS,
  convertToPNG,NUMBER_VALIDATION
} from "../../utils/common.service";

export default function AddLetter() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    control,
    setValue,
    clearErrors,
  } = useForm();

  const [logoState, setLogoState] = useState(null);
  const [latterImageState, setLatterImageState] = useState(null);
  //const [backgroundImageState, setBackgroundImageState] = useState(null);
  const [categories, setCategories] = useState([]);
  const [font, setFont] = useState(localStorage.getItem("selectedFont") ?? "Ruqa"); 
  const [isActive, setIsActive] = useState("false"); // For toggle button

  const handleImageChange = async (image, setImageState, fieldName) => {
    if (!image || image.type !== "image/svg+xml") {
      TOAST_ERROR("Please select a valid SVG image file");
      return;
    }

    const imageSize = image.size / 1024; // convert size to KB
    if (imageSize > 3072) {
      TOAST_ERROR("Please select an image smaller than 3MB");
      return;
    }

    try {
      setValue(fieldName, image);
      const bufferImage = await convertToBase64(image);
      setImageState(bufferImage);
      clearErrors(fieldName);
    } catch (error) {
      TOAST_ERROR("An error occurred while processing the image");
    }
  };

  

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await API.getCategaryListApi();
        // console.log("response-----------------------------------------------------------",response);

        setCategories(response.data);
      } catch (error) {
        TOAST_ERROR("Failed to load categories");
      }
    };

    fetchCategories();
  }, []);

  const onSubmit = async (submitData) => {
    try {
      dispatch(setLoader(true));

      let {
        logo,
        latter_image,
       // background_image,
        points,
        description,
        ar_description,
        category,
        skip_point,
        total_used_line,
        font,
      } = submitData;

      // Initialize variables to hold URLs of uploaded images
      let uploadedLogo = logo;
      let uploadedLatterImage = latter_image;
      //let uploadedBackgroundImage = background_image;
      //let pngLogoUrl, pngLatterImageUrl, pngBackgroundImageUrl;

      let pngLogoUrl, pngLatterImageUrl;

      // Upload original images (only if they are Blob objects)
      if (logo instanceof Blob) {
        try {
          uploadedLogo = await uploadImageOnAWS(logo, "letter");
          const pngLogo = await convertToPNG(logo);
          pngLogoUrl = await uploadImageOnAWS(pngLogo, "letter");
        } catch (error) {
          TOAST_ERROR("Error uploading logo image");
        }
      }

      if (latter_image instanceof Blob) {
        try {
          uploadedLatterImage = await uploadImageOnAWS(latter_image, "letter");
          const pngLatterImage = await convertToPNG(latter_image);
          pngLatterImageUrl = await uploadImageOnAWS(pngLatterImage, "letter");
        } catch (error) {
          TOAST_ERROR("Error uploading letter image");
        }
      }

      // if (background_image instanceof Blob) {
      //   try {
      //     uploadedBackgroundImage = await uploadImageOnAWS(
      //       background_image,
      //       "letter"
      //     );
      //     const pngBackgroundImage = await convertToPNG(background_image);
      //     pngBackgroundImageUrl = await uploadImageOnAWS(
      //       pngBackgroundImage,
      //       "letter"
      //     );
      //   } catch (error) {
      //     TOAST_ERROR("Error uploading background image");
      //   }
      // }

      // Construct the request body and make sure to send `is_free` as a boolean
      const requestBody = {
        logo: uploadedLogo,
        latter_image: uploadedLatterImage,
       // background_image: uploadedBackgroundImage,
        png_logo: pngLogoUrl,
        png_latter_image: pngLatterImageUrl,
       // png_background_image: pngBackgroundImageUrl,
        points,
        description,
        ar_description,
        category,
        skip_point,
        total_used_line,
        is_free: isActive,
        font,
      };

      // console.log(
      //   "55555555555555555555555555555555555555555555555555555",
      //   requestBody
      // );

      // Make the API call
      const { code, message } = await API.insertLatterApi(requestBody);

      if (code === "1") {
        SWIT_SUCCESS(message);
        navigate(`/manage_latter`);
        reset();
      }

      dispatch(setLoader(false));
    } catch (err) {
      TOAST_ERROR(err.message);
      dispatch(setLoader(false));
    }
  };

  return (
    <>
      <div className="content">
        <div className="container-fluid">
          <SubNavbar
            title="Add Letter"
            header="letter"
            subHeader="Add Letter"
          />
          <div className="card rounded-3">
            <div className="card-body">
              <div className="d-flex justify-content-lg-start">
                <button
                  type="button"
                  className="btn btn-light"
                  onClick={() => navigate(-1)}
                >
                  <IoMdArrowRoundBack fontSize={"20px"}/>
                </button>
              </div>
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="row mb-3">
                  {/* Logo Image */}
                  <Controller
                    name="logo"
                    control={control}
                    defaultValue={null}
                    rules={{ required: "Please choose a logo image" }}
                    render={({ field }) => (
                      <div className="col-md-6 text-center">
                        {logoState && (
                          <img
                            src={logoState}
                            alt="logo image"
                            className="img-fluid img-thumbnail"
                            style={{
                              width: "120px",
                              height: "120px",
                              borderRadius: "10%",
                            }}
                          />
                        )}
                        <input
                          type="file"
                          style={{ display: "none" }}
                          id="logo"
                          accept="image/svg+xml"
                          onChange={(e) =>
                            handleImageChange(
                              e.target.files[0],
                              setLogoState,
                              "logo"
                            )
                          }
                        />
                        <label
                          htmlFor="logo"
                          className="btn btn-outline-info m-1"
                        >
                          Choose Logo Image
                        </label>
                        <div className="errorc">{errors.logo?.message}</div>
                      </div>
                    )}
                  />

                  {/* Letter Image */}
                  <Controller
                    name="latter_image"
                    control={control}
                    defaultValue={null}
                    rules={{ required: "Please choose a letter image" }}
                    render={({ field }) => (
                      <div className="col-md-6 text-center">
                        {latterImageState && (
                          <img
                            src={latterImageState}
                            alt="letter image"
                            className="img-fluid img-thumbnail"
                            style={{
                              width: "120px",
                              height: "120px",
                              borderRadius: "10%",
                            }}
                          />
                        )}
                        <input
                          type="file"
                          style={{ display: "none" }}
                          id="latter_image"
                          accept="image/svg+xml"
                          onChange={(e) =>
                            handleImageChange(
                              e.target.files[0],
                              setLatterImageState,
                              "latter_image"
                            )
                          }
                        />
                        <label
                          htmlFor="latter_image"
                          className="btn btn-outline-info m-1"
                        >
                          Choose Letter Image
                        </label>
                        <div className="errorc">
                          {errors.latter_image?.message}
                        </div>
                      </div>
                    )}
                  />

                  {/* Background Image */}
                  {/* <Controller
                    name="background_image"
                    control={control}
                    defaultValue={null}
                    rules={{ required: "Please choose a background image" }}
                    render={({ field }) => (
                      <div className="col-md-4 text-center">
                        {backgroundImageState && (
                          <img
                            src={backgroundImageState}
                            alt="background image"
                            className="img-fluid img-thumbnail"
                            style={{
                              width: "120px",
                              height: "120px",
                              borderRadius: "10%",
                            }}
                          />
                        )}
                        <input
                          type="file"
                          style={{ display: "none" }}
                          id="background_image"
                          accept="image/svg+xml"
                          onChange={(e) =>
                            handleImageChange(
                              e.target.files[0],
                              setBackgroundImageState,
                              "background_image"
                            )
                          }
                        />
                        <label
                          htmlFor="background_image"
                          className="btn btn-outline-info m-1"
                        >
                          Choose Background Image
                        </label>
                        <div className="errorc">
                          {errors.background_image?.message}
                        </div>
                      </div>
                    )}
                  /> */}
                </div>

                {/* Point Input */}
                <div className="row mb-3">
                  <div className="col-6">
                    <label htmlFor="points" className="form-label">
                      Points
                    </label>
                    <input
                      type="text"
                      id="points"
                      className="form-control"
                      placeholder="Enter points"
                      {...register("points", NUMBER_VALIDATION("points"))}aria-invalid={errors.email ? "true" : "false"}
                    />
                    <div className="errorc">{errors.points?.message}</div>
                  </div>

                  {/* Skip Point Field */}
                  <div className="col-6">
                    <label htmlFor="skip_point" className="form-label">
                      Skip Path
                    </label>
                    <input
                      type="number"
                      id="skip_point"
                      className="form-control"
                      placeholder="Enter skip points"
                      {...register("skip_point", NUMBER_VALIDATION("skip points"))}aria-invalid={errors.email ? "true" : "false"}
                    />
                    <div className="errorc">{errors.skip_point?.message}</div>
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-6">
                    <label htmlFor="total_used_line" className="form-label">
                     Total Line
                    </label>
                    <input
                      type="number"
                      id="total_used_line"
                      className="form-control"
                      placeholder="Enter skip points"
                      {...register("total_used_line", NUMBER_VALIDATION("total line"))}aria-invalid={errors.email ? "true" : "false"}
                    />
                    <div className="errorc">{errors.total_used_line?.message}</div>
                  </div>
                
                  <div className="col-6">
                    <label htmlFor="font" className="form-label">
                      Font
                    </label>
                    <select
                      id="font"
                      className="form-select"
                      aria-invalid={errors.font ? "true" : "false"}
                      {...register("font", {
                        required: "font is required",
                      })}
                      value={font}
                      onChange={(e) => {
                        setFont(e.target.value);
                        setValue("font", e.target.value); 
                      }}
                    >
                      <option key="Ruqa" value="Ruqa">Ruqa</option>
                      <option key="Naskh" value="Naskh">Naskh</option>
                    </select>
                    <div className="errorc">{errors.font?.message}</div>
                  </div>
                </div>
                {/* Category Dropdown */}
                <div className="row mb-3">
                  {/* <div className="col-md-6">
                    <label htmlFor="category" className="form-label">
                      Category
                    </label>
                    <select
                      id="category"
                      className="form-control"
                      {...register("category", {
                        required: "Category is required",
                      })}
                    >
                      <option value="">Select Category</option>
                      {categories?.map((category) => (
                        <option key={category.id} value={category.id}>
                          {category.name}
                        </option>
                      ))}
                    </select>
                    <div className="errorc">{errors.category?.message}</div>
                  </div> */}

                  <div className="col-md-12">
                    <label htmlFor="description" className="form-label">
                      Description
                    </label>
                    <textarea
                      id="description"
                      className="form-control"
                      placeholder="Enter description"
                      {...register("description")}
                    />
                    <div className="errorc">{errors.description?.message}</div>
                  </div>
                </div>
                <div className="row mb-3">
                <div className="col-md-12">
                    <label htmlFor="ar_description" className="form-label">
                      Description(Arabic)
                    </label>
                    <textarea
                      id="ar_description"
                      className="form-control"
                      placeholder="Enter description"
                      {...register("ar_description")}
                    />
                    <div className="errorc">{errors.ar_description?.message}</div>
                  </div>
                </div>

                {/* Toggle Button */}
                <div className="form-check form-switch mb-3">
                  <label className="form-check-label" htmlFor="is_active">
                    Is This Free
                  </label>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="is_active"
                    checked={isActive === "true"}
                    onChange={() =>
                      setIsActive(isActive === "true" ? "false" : "true")
                    }
                  />
                </div>

                <div className="mb-0 text-center">
                  <button
                    className="btn btn-soft-primary w-25 buttonColor"
                    type="submit"
                  >
                    <i className="ri-save-fill"></i>{" "}
                    <span className="fw-bold">Add</span>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
